import './components.css';

const Maincard = ({ cardItems = [], loading, colSize = 2, mainCol = 8 }) => {
    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                <div className="card-body">
                    <div className="row justify-content-center">
                    {/* <div className={`align-self-center col-lg-${2}`}></div> */}
                    <div className={`align-self-center col-lg-${mainCol}`}>
                        <h6 className="mb-3">Filtered Information</h6>
                        <div className="text-lg-center mt-4 mt-lg-0">
                        <div className="row justify-content-center">
                            {cardItems.length > 0 ? (
                            cardItems.map((item, index) => (
                                <div
                                className={`col-md-${colSize} col-sm-6 mb-3`}
                                key={item.key || index}
                                >
                                <div className="maincard-border p-3">
                                    <p className="text-muted text-truncate mb-2">{item.title}</p>
                                    {!loading ? (
                                    <h5 className="mb-0">{item.value ?? 0}</h5>
                                    ) : (
                                    <h5 className="card-title placeholder-glow">
                                        <span className="placeholder col-6"></span>
                                    </h5>
                                    )}
                                </div>
                                </div>
                            ))
                            ) : (
                            <p className="text-muted">No data available</p>
                            )}
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>  
        </div>
    );
};

export default Maincard;
